// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__37aD8","tags_container":"Tags_tags_container__FS8Lb"};